import React, { useState, useEffect, useRef } from "react";
import RAILWAY_CONST from "../utils/RailwayConst";
import { apiService } from "../utils/apiService";
import { format, subDays } from "date-fns";
import { DateRange } from "react-date-range";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";

import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Toast } from "primereact/toast";
// import LocoPilotReportTable from "./LocoPilotReportTable";

export default function LocoPilotReportTable() {
  const toastRef = useRef();
  const [loading, setLoading] = useState(false);
  const [reportTableData, setReportTableData] = useState([]); // DataTable state
  const [range, setRange] = useState([
    {
      startDate: subDays(new Date(), 30),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: "contains" },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const getreportDataTable = async (start_date, end_date) => {
    const url = `${RAILWAY_CONST.API_ENDPOINT.MANAGEMENT_lP_SUMMARY}?start_date=${start_date}&end_date=${end_date}`;
    try {
      const response = await apiService("get", url);
      setReportTableData(response.data);
    } catch (error) {
      console.error("Error fetching chart data:", error);
      toastRef.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch report data. Please try again later.",
        life: 3000,
      });
    }
  };

  useEffect(() => {
    // Initial fetch for default date range
    const formattedStartDate = format(range[0].startDate, "yyyy-MM-dd");
    const formattedEndDate = format(range[0].endDate, "yyyy-MM-dd");
    getreportDataTable(formattedStartDate, formattedEndDate);
  }, []);

  const handleSelect = (item) => {
    setRange([item.selection]);
    const formattedStartDate = format(item.selection.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item.selection.endDate, "yyyy-MM-dd");

    // getChartReportData(formattedStartDate, formattedEndDate);
    if (
      formattedStartDate &&
      formattedEndDate &&
      formattedStartDate !== formattedEndDate
    ) {
      setRange([item.selection]);
      getreportDataTable(formattedStartDate, formattedEndDate);
      setOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setFilters({
      ...filters,
      global: { value, matchMode: "contains" },
    });
    setGlobalFilterValue(value);
  };
  return (
    <>
      <Toast ref={toastRef} position="top-right" />
      <h1 className="sm:text-[18px] rounded-[5px] bg-[#2A235A] text-white flex-row flex justify-between items-center text-[18px] font-medium mb-1 border-b border-[#ccc] relative px-3 py-[6px] locoPilotTitle">
        <span>Loco Pilot Report</span>
        <div className="relative z-20 flex flow-row datePickerCol mt-1 text-[14px]">
          <label className="text-[14px] inline-block min-w-[110px] pr-3 sm:mb-0 mt-1">
            Date Range :
          </label>
          <input
            readOnly
            value={`${format(range[0].startDate, "dd/MM/yyyy")} - ${format(
              range[0].endDate,
              "dd/MM/yyyy"
            )}`}
            onClick={() => setOpen(!open)}
            className="border px-1 py-2 rounded-md w-[240px] cursor-pointer inputbox pl-2 -mt-1"
          />
          {open && (
            <div
              ref={ref}
              className="absolute z-10 mt-[44px] shadow-lg border right-0 bg-white font-normal"
            >
              <DateRange
                editableDateInputs
                onChange={handleSelect}
                moveRangeOnFirstSelection={false}
                ranges={range}
                months={2}
                direction={window.innerWidth > 600 ? "horizontal" : "vertical"}
              />
            </div>
          )}

          <div className="pl-4 -mt-1 searchCol">
            <InputText
              value={globalFilterValue}
              onChange={onGlobalFilterChange}
              placeholder="Search for any field"
              className="w-56 h-10 -mb-1 inline-block border border-gray-300 rounded-md pl-2 globleFilter bg-transparent text-white font-normal"
              style={{ marginLeft: "auto" }}
            />
          </div>
        </div>
      </h1>
      <div className="bg-white w-full rounded-[15px] min-h-[900px]">
        <div style={{ overflowX: "auto", width: "100%" }}>
          {/* <h1 className="sm:text-[22px] text-[18px] text-[#30424c] font-medium mb-8 border-b border-[#ccc] pb-2 relative pt-2">
            Loco Pilot Report
          </h1> */}

          {/* <div className="flex justify-between items-center mb-4">
                        <div></div> 
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Search for any field"
                            className="w-56 h-12 inline-block border border-gray-300 rounded-md pl-2 globleFilter"
                            style={{ marginLeft: "auto", }}
                        />
                    </div> */}
          <DataTable
            value={reportTableData}
            paginator
            rows={10}
            stripedRows
            sortMode="multiple"
            dataKey={reportTableData.id}
            filters={filters}
            filterDisplay="row"
            loading={loading}
            emptyMessage="No data found"
            globalFilterFields={["crew_name", "lp_cms_id"]}
            className="mt-2"
          >
            <Column field="lp_cms_id" header="LP CMS ID" sortable />
            <Column field="crew_name" header="Crew Name" sortable />
            <Column field="psr_err_count" header="PSR Violation" sortable />
            <Column field="tsr_err_count" header="TSR Violation" sortable />
            <Column
              field="attacking_speed_violation_count"
              header="Attacking Speed Violation"
              sortable
            />

            {/* Add more columns based on your data */}
          </DataTable>
        </div>
      </div>
    </>
  );
}
